import React, { useState, Fragment, useEffect, lazy } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';

import PnIcon from './PnIcon';
import {
  login,
  checkLogin,
  continueWithoutLogin,
  showModalLogin,
} from '../Actions/ModalLogin.action';
//import { toggleForceShowOrganizationSelector } from '../../_Addons/PNOrganizationSelector/Actions/OrganizationSelector.action';
import DynamicComponent from '../../Components/DynamicComponent';

const ModalLogin = ({ checkIfLoggedOn = false }) => {
  const [showLogin, setShowLogin] = useState(false);
  const [OrgSelector, SetOrgSelector] = useState(null);
  const [usrName, setUsrName] = useState('');
  const [loginAttempt, setLoginAttempt] = useState(0); 
  const [psw, setPsw] = useState('');
  const dispatch = useDispatch();

  //const OrganizationSelectorContainer = lazy(() =>
  //  import(
  //    '../../_Addons/PNOrganizationSelector/Components/OrganizationSelectorContainer'
  //  ).catch(() => ({
  //    default: () => null,
  //  }))
  //);

  const {
    visible,
    isLoggedOnModal,
    loginSuccess,
    showOrganizationSelector,
    errorMessage,
    modalLoginData,
    callbackOk,
  } = useSelector((state) => state.loginModal);

  const onLogin = () => {
    dispatch(login(usrName, psw));
    setTimeout(() => {
      setLoginAttempt(loginAttempt + 1);
    }, 200);
  };

  const onSkip = () => {
    dispatch(continueWithoutLogin());
    dispatch(showModalLogin(false));
  };

  const renderSelectOrganization = () => {
    const OrganizationSelector = DynamicComponent({
      loader: () =>
        import(
          '../../_Addons/PNOrganizationSelector/Components/OrganizationSelectorContainer'
        ),
    });
    if (OrganizationSelector) {
      return <OrganizationSelector />;
    }
    alert('Please add the Addon [Organization selector] to the solution');
    return null;
  };

  //import(
  //  '../../_Addons/PNOrganizationSelector/Actions/OrganizationSelector.action'
  //).then((orgSelector) => {
  //  dispatch(orgSelector.toggleForceShowOrganizationSelector(true));
  //});

  useEffect(() => {
    // OnInit
    if (callbackOk && checkIfLoggedOn) {
      if (!isLoggedOnModal) {
        setShowLogin(true);
      } else {
        setShowLogin(false);
      }
    }
  }, [callbackOk, isLoggedOnModal]);

  //useEffect(() => {
  //  // OnInit
  //  if (showOrganizationSelector) {
  //    import(
  //      '../../_Addons/PNOrganizationSelector/Actions/OrganizationSelector.action'
  //    ).then((orgSelector) => {
  //      dispatch(orgSelector.toggleForceShowOrganizationSelector(true));
  //    });
  //  }
  //}, [showOrganizationSelector]);

  useEffect(() => {
    //const fetchObject = async () => {
    //  //const data = await fetch('https://yourapi.com');

    //  const OrganizationSelector = DynamicComponent({
    //    loader: () =>
    //      import(
    //        '../../_Addons/PNOrganizationSelector/Components/OrganizationSelectorContainer'
    //      ),
    //  });
    //  if (OrganizationSelector) {
    //    SetOrgSelector(OrganizationSelector);
    //  }
    //  //return null;
    //};
    //fetchObject();

    // OnInit
    dispatch(checkLogin(false));
  }, []);
  useEffect(() => {
    setShowLogin(visible);
  }, [visible]);

  if (showLogin) {
    return (
      <Fragment>
        {showLogin && <div className="modal-login__overlay"></div>}
        <div className="modal-login">
          <div className="form__container">
            <h2>{translate('common.login.loggedout.header')}</h2>
            {errorMessage && (
              <section className="modal-login__error-message">
                {errorMessage}{' '}
                <PnIcon
                  iconName="warning"
                  width="24px"
                  height="24px"
                  title={translate('common.login.loggedout.header')}
                ></PnIcon>
                <br />
                <small>
                  ({translate('common.login.attemt.number')} {loginAttempt})
                </small>
              </section>
            )}
            {/*<OrganizationSelectorContainer />*/}
            {!showOrganizationSelector ? (
              <fieldset className="form">
                <div className="modal-login__input-area">
                  <label className="form__label" htmlFor="LoginForm_UserName">
                    {translate('common.login.loggedout.username')}
                  </label>
                  <input
                    autoComplete="username"
                    className="form__input"
                    id="LoginForm_UserName"
                    type="text"
                    value={usrName}
                    onChange={(e) => setUsrName(e.target.value)}
                  />
                  <span className="form__validator--error field-validation-valid"></span>
                </div>
                <div className="modal-login__input-area">
                  <label className="form__label" htmlFor="LoginForm_Password">
                    {translate('common.login.loggedout.password')}
                  </label>
                  <input
                    autoComplete="current-password"
                    className="form__input"
                    id="LoginForm_Password"
                    name="LoginForm.Password"
                    type="password"
                    value={psw}
                    onChange={(e) => setPsw(e.target.value)}
                  />
                  <span className="form__validator--error field-validation-valid"></span>
                </div>
                <section className="row modal-login__button-container">
                  <div className="small-12 medium-6 columns">
                    <button
                      className="form__button form__button--expand"
                      onClick={() => onSkip()}
                    >
                      {translate('general.cancel')}
                      <br />
                      <small>
                        ({translate('common.login.loggedout.skip')})
                      </small>
                    </button>
                  </div>
                  <div className="small-12 medium-6 columns">
                    <button
                      className="form__button form__button--expand"
                      onClick={() => onLogin()}
                      disabled={psw.length < 2 || usrName.length < 2}
                    >
                      {translate('common.login.loggedout.button')}
                    </button>
                  </div>
                </section>
              </fieldset>
            ) : (
              <fieldset className="form">
                {' '}
                <div></div>
              </fieldset>
            )}
          </div>

          {/*<iframe*/}
          {/*  src="/login.loginmodal"*/}
          {/*  width={300}*/}
          {/*  height={400}*/}
          {/*  referrerpolicy="same-origin"*/}
          {/*  sandbox="allow-scripts allow-forms allow-modals allow-popups-to-escape-sandbox allow-same-origin"*/}
          {/*></iframe>*/}
        </div>
      </Fragment>
    );
  } else return null;
};

export default ModalLogin;
